import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 56;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const getNavClass = (path) => {
    return location.pathname === path ? 'nav-item active' : 'nav-item';
  };

  return (
    <nav className={`navbar navbar-expand-md fixed-top navbar-dark shadow navbar-bg-1 ${scrolled || isOpen ? 'navbar-bg-2' : ''}`}>
      <div className="container">
        <Link className="navbar-brand" to="/">Santo Cristo de la Piedad</Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleNavbar}
          aria-controls="navbarCollapse" 
          aria-expanded={isOpen} 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarCollapse">
          <ul className="navbar-nav ms-auto">
            <li className={getNavClass('/')}>
              <Link className="nav-link" to="/">Principal</Link>
            </li>
            <li className={getNavClass('/historia')}>
              <Link className="nav-link" to="/historia">Historia</Link>
            </li>
            <li className={getNavClass('/testimonios')}>
              <Link className="nav-link" to="/testimonios">Testimonios</Link>
            </li>
            <li className={getNavClass('/oraciones')}>
              <Link className="nav-link" to="/oraciones">Oraciones</Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#contact">Contactenos</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;